<div class="footer-dark">
  <img src="/static/images/auth/logo-dark.svg">
  <h4>Illuminating uncertainty.</h4>
  <a>signaloid.com</a>
  <mat-divider></mat-divider>
  <p>© 2024 Nucleus Design System</p>
</div>
